
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91_91id_93_93I9N11GBVBthK1yetqmIL1MccCvEa8q5hi_t_1CzIpFQMeta } from "/app/app/pages/demo/depth/[[id]].vue?macro=true";
import { default as backfillipQ0Jg_5k_Byy6pRcbBGXpAvbAjVceEyyYP36OWUpaYMeta } from "/app/app/pages/admin/backfill.vue?macro=true";
import { default as filesT0c_taogEcWW_Xc86iy85YTly5UEHyD8BRBVu_a_hYkMeta } from "/app/app/pages/admin/files.vue?macro=true";
import { default as login9SwqjP9nAX4wp18E4sI7DKoKXJnXO1DIZ03LeN26lzQMeta } from "/app/app/pages/admin/login.vue?macro=true";
import { default as seriesV4pMDC5gR37FBmZ2G98pLFM8_VrV_IRvRUPnKpisgAoMeta } from "/app/app/pages/admin/series.vue?macro=true";
import { default as site3pDhKc714XoV2lOjVyc6LUoDX2PKFRO_bXPK1_kmMQMMeta } from "/app/app/pages/admin/site.vue?macro=true";
import { default as uploadnsAwD7Csxi0n9vdd8JulP2qCCBkYdfITDJmgrwk0u_0Meta } from "/app/app/pages/admin/upload.vue?macro=true";
import { default as _91slug_93UWcktwxzPeimuvUmEqPyRCSLW1zpUJsrFRer6LKOA8wMeta } from "/app/app/pages/series/[slug].vue?macro=true";
import { default as indexBGbi9mJzJJpiRjuRhKvga_0QspKTUlmVO0QyRz6Z3r8Meta } from "/app/app/pages/admin/index.vue?macro=true";
import { default as mapIIsuIP1VvnVnA23SmSCFaXHhYhz4WXbCUwBp0srclwQMeta } from "/app/app/pages/map.vue?macro=true";
import { default as indexVhvnRGzp58SJOVAZLXVK_rGhkodbqBEtmHN79869DSAMeta } from "/app/app/pages/series/index.vue?macro=true";
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
export default [
  {
    name: "demo-depth-id",
    path: "/demo/depth/:id?",
    component: () => import("/app/app/pages/demo/depth/[[id]].vue")
  },
  {
    name: "admin-backfill",
    path: "/admin/backfill",
    meta: { ...(backfillipQ0Jg_5k_Byy6pRcbBGXpAvbAjVceEyyYP36OWUpaYMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/app/pages/admin/backfill.vue")
  },
  {
    name: "admin-files",
    path: "/admin/files",
    meta: { ...(filesT0c_taogEcWW_Xc86iy85YTly5UEHyD8BRBVu_a_hYkMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/app/pages/admin/files.vue")
  },
  {
    name: "admin-login",
    path: "/admin/login",
    component: () => import("/app/app/pages/admin/login.vue")
  },
  {
    name: "admin-series",
    path: "/admin/series",
    meta: { ...(seriesV4pMDC5gR37FBmZ2G98pLFM8_VrV_IRvRUPnKpisgAoMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/app/pages/admin/series.vue")
  },
  {
    name: "admin-site",
    path: "/admin/site",
    meta: { ...(site3pDhKc714XoV2lOjVyc6LUoDX2PKFRO_bXPK1_kmMQMMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/app/pages/admin/site.vue")
  },
  {
    name: "admin-upload",
    path: "/admin/upload",
    meta: { ...(uploadnsAwD7Csxi0n9vdd8JulP2qCCBkYdfITDJmgrwk0u_0Meta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/app/app/pages/admin/upload.vue")
  },
  {
    name: "series-slug",
    path: _91slug_93UWcktwxzPeimuvUmEqPyRCSLW1zpUJsrFRer6LKOA8wMeta?.path ?? "/series/:slug()",
    meta: _91slug_93UWcktwxzPeimuvUmEqPyRCSLW1zpUJsrFRer6LKOA8wMeta || {},
    component: () => import("/app/app/pages/series/[slug].vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: {"middleware":"admin-auth"},
    component: () => import("/app/app/pages/admin/index.vue")
  },
  {
    name: "map",
    path: "/map",
    meta: mapIIsuIP1VvnVnA23SmSCFaXHhYhz4WXbCUwBp0srclwQMeta || {},
    component: () => import("/app/app/pages/map.vue")
  },
  {
    name: "series",
    path: "/series",
    meta: indexVhvnRGzp58SJOVAZLXVK_rGhkodbqBEtmHN79869DSAMeta || {},
    component: () => import("/app/app/pages/series/index.vue")
  },
  {
    name: "index",
    path: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta?.path ?? "/",
    meta: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {},
    component: () => import("/app/app/pages/index.vue")
  }
]